<template>
  <transition name="ok-modal__fade">
    <div class="ok-modal ods-flex-align-items-center ods-flex-justify-content-center">
      <div class="ok-modal__outer" aria-hidden="true" tabindex="0" @keydown.esc="close" @click="close" />
      <div
        class="ok-modal__inner ods-flex ods-flex-direction-column ods-color-bg-white"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        tabindex="0"
        @keydown.esc="close"
        @click.stop=""
      >
        <header
          class="ok-modal__header ods-flex ods-flex-align-items-center ods-flex-justify-content-space-between ods-padding-left-4"
        >
          <h2 id="modalTitle" class="ok-modal__title ods-text--size-kilo">
            <slot name="headerText"></slot>
          </h2>
          <button
            type="button"
            class="ok-modal__close ods-padding-4 ods-text--align-center ods-text--size-kilo ods-text--size-juliett-breakpoint-medium"
            :aria-label="$t('shared.close')"
            tabindex="0"
            @click="close"
          >
            Lukk
          </button>
        </header>
        <section id="modalDescription" class="ok-modal__body ods-text--size-juliett">
          <slot name="body"></slot>
        </section>
        <footer v-if="hasFooter" class="ok-modal__footer ods-padding-4">
          <slot name="footer">
            <div class="ods-grid ods-grid--gap">
              <button type="button" class="ods-grid__column--1 ods-button" @click="confirm">
                {{ $t('shared.confirm') }}
              </button>
              <button type="button" class="ods-button ods-button--outline" @click="close">
                {{ $t('shared.decline') }}
              </button>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OkModal',
  props: {
    hasFooter: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss">
@use '~@ods/system/colors' as *;

$padding: 1rem;
$borderColor: $gray-light;
$borderRadius: 2px;
$backdrop: rgba(black, 0.35);
$maxWidth: 32rem;
$fadeDuration: 0.2s;
$flipDuration: 0.2s;

.ok-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  outline: 1px solid purple;

  &__outer {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background: $backdrop;

    &:focus {
      outline: none;
    }
  }

  &__inner {
    width: 100%;
    min-width: 18rem;
    max-width: $maxWidth;
    border-radius: $borderRadius;
    box-shadow: 0 0.15rem 0.25rem $backdrop, 0 0.25rem 1.5rem rgba($backdrop, 0.35);
    transform: rotateX(90deg); // default view state
    animation: flip $flipDuration $fadeDuration ease forwards;

    &:focus {
      outline: none;
    }
  }

  &__header {
    border-bottom: 1px solid $borderColor;
  }

  &__title {
    margin: 0;
    padding: 0.25rem 0 0;
  }

  &__close {
    background: none;
    border: 0;
    cursor: pointer;

    &:hover {
      background: $borderColor;
    }

    & > .ok-icon {
      font-size: 1.25rem;
    }
  }

  &__body {
    padding: $padding * 1.5 $padding;
  }

  &__footer {
    border-top: 1px solid $borderColor;
  }

  &__fade-enter-from,
  &__fade-leave-active {
    opacity: 0;
  }

  &__fade-enter-active,
  &__fade-leave-active {
    transition: opacity $fadeDuration ease-out;
  }
}

@keyframes flip {
  from {
    transform: rotateX(90deg);
  }
  to {
    transform: rotateX(0);
  }
}
</style>
